/* Packrift additive onsite search. No cart or catalog mutations. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.init(root);
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var NUMBER = '(?:\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|\\d+(?:\\.\\d+)?)';
  var SEPARATOR = '\\s*(?:[xX×]|\\bby\\b)\\s*';
  function dimensionPattern() {
    // Consume the whole tuple: neither 48x6x6 nor 8x6x6x4 can match 8x6x6.
    return new RegExp('(?<![\\w./])' + NUMBER + '(?:' + SEPARATOR + NUMBER + ')+(?![\\w./])', 'gi');
  }
  function normalizeQuery(value) {
    return String(value == null ? '' : value).replace(dimensionPattern(), function (tuple) {
      return tuple.replace(/\s*(?:[xX×]|\bby\b)\s*/gi, 'x');
    });
  }
  function numberValue(value) {
    var parts = value.trim().split(/\s+/);
    var fraction = parts[parts.length - 1].split('/');
    if (fraction.length === 2) {
      if (Number(fraction[1]) === 0) return NaN;
      return (parts.length === 2 ? Number(parts[0]) : 0) + Number(fraction[0]) / Number(fraction[1]);
    }
    return Number(value);
  }
  function dimensions(value) {
    return (String(value).match(dimensionPattern()) || []).map(function (tuple) {
      return normalizeQuery(tuple).split('x').map(numberValue);
    }).filter(function (tuple) { return tuple.every(Number.isFinite); });
  }
  function sameTuple(a, b) {
    return a.length === b.length && a.every(function (n, i) { return Math.abs(n - b[i]) < 1e-8; });
  }
  function canonicalProductUrl(value, origin) {
    try {
      var url = new URL(value, origin);
      if (url.origin !== origin || url.username || url.password || !/^https?:$/.test(url.protocol)) return null;
      if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return null;
      // A canonical product page, without predictive-search tracking or variant claims.
      return url.origin + url.pathname;
    } catch (_) { return null; }
  }
  function dimensionRecords(value) {
    var text = String(value), pattern = dimensionPattern(), match, records = [];
    while ((match = pattern.exec(text))) {
      var tuple = dimensions(match[0])[0];
      if (!tuple) continue;
      // Compare explicit trailing units when supplied; never infer a missing unit.
      var suffix = text.slice(pattern.lastIndex);
      var unitMatch = suffix.match(/^\s*((?:mm|millimet(?:er|re)s?|cm|centimet(?:er|re)s?|inches|inch|in|ft|feet|foot)\b|["″]|['′])/i);
      var unit = unitMatch ? unitMatch[1].toLowerCase() : '';
      if (/^(mm|milli)/.test(unit)) unit = 'mm';
      else if (/^(cm|centi)/.test(unit)) unit = 'cm';
      else if (/^(in|["″])/.test(unit)) unit = 'in';
      else if (unit) unit = 'ft';
      records.push({ tuple: tuple, unit: unit });
    }
    return records;
  }
  function hasExactSku(product, query) {
    // Only returned SKU data is evidence. Keep punctuation: AB-12 is not AB12.
    var needle = String(query).trim().toLowerCase();
    var skus = [product.sku];
    if (Array.isArray(product.variants)) product.variants.forEach(function (variant) {
      if (variant) skus.push(variant.sku);
    });
    return skus.some(function (sku) {
      return typeof sku === 'string' && sku.trim().length > 0 && sku.trim().toLowerCase() === needle;
    });
  }
  function rankProducts(products, query, origin, limit) {
    var wanted = dimensionRecords(query);
    var exactSku = [], exact = [], alternatives = [], seen = new Set();
    (Array.isArray(products) ? products : []).slice(0, 10).forEach(function (product) {
      if (!product || typeof product.title !== 'string' || typeof product.url !== 'string') return;
      var url = canonicalProductUrl(product.url, origin);
      if (!url || seen.has(url)) return;
      seen.add(url);
      var found = dimensionRecords(product.title);
      var matched = wanted.length > 0 && wanted.every(function (record) {
        return found.some(function (candidate) {
          return sameTuple(record.tuple, candidate.tuple)
            && (!record.unit || record.unit === candidate.unit);
        });
      });
      var skuMatched = hasExactSku(product, query);
      var item = { title: product.title.slice(0, 300), url: url,
        match: skuMatched ? 'exact_sku' : (matched ? 'same_dimensions' : (wanted.length ? 'other_size_or_unspecified' : 'search_result')) };
      (skuMatched ? exactSku : (matched ? exact : alternatives)).push(item);
    });
    var cap = Math.max(1, Math.min(5, limit || 5));
    exactSku = exactSku.slice(0, cap);
    exact = exact.slice(0, cap - exactSku.length);
    alternatives = alternatives.slice(0, cap - exactSku.length - exact.length);
    return { normalized_query: normalizeQuery(query), has_dimensions: wanted.length > 0,
      exact_sku: exactSku, exact: exact, alternatives: alternatives,
      match_scope: 'SKU matches require returned SKU data. Dimensions compare numbers and order in product titles; missing units are not inferred. Check units, grade, material, pack count and availability on the product page.' };
  }
  function searchError(name, message) {
    var error = new Error(message); error.name = name; return error;
  }
  function createSearchClient(options) {
    var origin = new URL(options.origin).origin;
    var route = String(options.root || '/');
    // Shopify locale roots only; never accept a network location from configuration.
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(route)) route = '/';
    var cache = new Map();
    var cacheSize = Math.max(0, Math.min(40, options.cacheSize == null ? 40 : options.cacheSize));
    var cacheTtl = Math.max(0, Math.min(60000, options.cacheTtlMs == null ? 60000 : options.cacheTtlMs));
    var timeoutMs = Math.max(1, options.timeoutMs == null ? 4000 : options.timeoutMs);
    var now = options.now || Date.now;
    function copy(result) { return JSON.parse(JSON.stringify(result)); }
    function normalize(value) { return normalizeQuery(value).trim().slice(0, 200); }
    function fresh(time) { var age = now() - time; return Number.isFinite(time) && age >= 0 && age < cacheTtl; }
    // One session key, at most 40 suggestions sets across reloads. Never persist
    // provider payloads, prices, inventory, or user/account identifiers.
    var storage = options.storage, storageKey = 'packrift:search-suggestions:v1';
    var scope = JSON.stringify([origin, route, String(options.locale || ''), String(options.country || '')]);
    function validatedResult(value, key) {
      if (!value || typeof value !== 'object') return null;
      var result = rankProducts([], key, origin, 5), seen = new Set(), count = 0;
      var groups = ['exact_sku', 'exact', 'alternatives'];
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i], items = value[group];
        if (!Array.isArray(items) || items.length > 5) return null;
        for (var j = 0; j < items.length; j++) {
          var item = items[j];
          var label = group === 'exact_sku' ? 'exact_sku' : (group === 'exact' ? 'same_dimensions'
            : (result.has_dimensions ? 'other_size_or_unspecified' : 'search_result'));
          if (!item || typeof item.title !== 'string' || item.title.length > 300
            || typeof item.url !== 'string' || item.url.length > 2048 || item.match !== label
            || canonicalProductUrl(item.url, origin) !== item.url || seen.has(item.url) || ++count > 5) return null;
          if (group === 'exact' && !rankProducts([item], key, origin, 5).exact.length) return null;
          seen.add(item.url);
          result[group].push({ title: item.title, url: item.url, match: label });
        }
      }
      return result;
    }
    // Storage is optional: privacy settings, corrupt JSON and quota failures must
    // never interfere with the in-memory cache or native search fallback.
    if (storage && cacheSize && cacheTtl) {
      try {
        var raw = storage.getItem(storageKey);
        if (raw && raw.length <= 128000) {
          var saved = JSON.parse(raw);
          if (saved && saved.scope === scope && Array.isArray(saved.entries) && saved.entries.length <= 40) {
            saved.entries.forEach(function (entry) {
              if (!entry || typeof entry.key !== 'string' || entry.key.length < 2 || entry.key.length > 200
                || normalize(entry.key).toLowerCase() !== entry.key || !fresh(entry.time)) return;
              var result = validatedResult(entry.result, entry.key);
              if (result) { cache.delete(entry.key); cache.set(entry.key, { time: entry.time, result: result }); }
            });
            while (cache.size > cacheSize) cache.delete(cache.keys().next().value);
          }
        }
      } catch (_) { /* Treat unreadable storage as a cold cache. */ }
    }
    function persist() {
      if (!storage) return;
      try {
        var entries = [];
        cache.forEach(function (entry, key) {
          if (fresh(entry.time)) entries.push({ key: key, time: entry.time, result: {
            exact_sku: entry.result.exact_sku, exact: entry.result.exact, alternatives: entry.result.alternatives
          } });
        });
        var raw = JSON.stringify({ scope: scope, entries: entries });
        if (raw.length <= 128000) storage.setItem(storageKey, raw);
      } catch (_) { storage = null; /* Keep memory caching if persistence fails. */ }
    }
    function peek(query) {
      var normalized = normalize(query), key = normalized.toLowerCase(), cached = cache.get(key);
      if (!cached) return null;
      if (!fresh(cached.time)) { cache.delete(key); return null; }
      cache.delete(key); cache.set(key, cached);
      var hit = copy(cached.result); hit.normalized_query = normalized; return hit;
    }
    var search = async function (query, signal) {
      var normalized = normalize(query);
      if (signal && signal.aborted) throw searchError('AbortError', 'Search cancelled');
      if (normalized.length < 2) return rankProducts([], normalized, origin, 5);
      var hit = peek(normalized);
      if (hit) return hit;
      var key = normalized.toLowerCase();
      var url = new URL(route + 'search/suggest.json', origin);
      url.searchParams.set('q', normalized);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,variants.barcode');
      var controller = new AbortController(), timer, onAbort;
      // Reject even if a transport ignores abort, including while JSON is being read.
      var stopped = new Promise(function (_, reject) {
        onAbort = function () { controller.abort(); reject(searchError('AbortError', 'Search cancelled')); };
        if (signal) signal.addEventListener('abort', onAbort, { once: true });
        timer = setTimeout(function () {
          controller.abort(); reject(searchError('TimeoutError', 'Search timed out'));
        }, timeoutMs);
      });
      try {
        var request = (async function () {
          var response = await options.fetch(url.href, { signal: controller.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Predictive search unavailable (' + response.status + ')');
          var data = await response.json();
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          if (!Array.isArray(products)) throw new Error('Unexpected predictive search response');
          return rankProducts(products, normalized, origin, 5);
        })();
        var result = await Promise.race([request, stopped]);
        if (signal && signal.aborted) throw searchError('AbortError', 'Search cancelled');
        if (cacheSize && cacheTtl) {
          cache.delete(key); cache.set(key, { time: now(), result: copy(result) });
          while (cache.size > cacheSize) cache.delete(cache.keys().next().value);
          persist();
        }
        return result;
      } finally {
        clearTimeout(timer);
        if (signal) signal.removeEventListener('abort', onAbort);
      }
    };
    search.peek = peek;
    return search;
  }
  function createLatestSearch(search, onResult, onError) {
    var generation = 0, controller = null;
    function cancel() { generation += 1; if (controller) controller.abort(); controller = null; }
    return { cancel: cancel, run: async function (query) {
      cancel();
      var current = generation;
      controller = new AbortController();
      var signal = controller.signal;
      try {
        var result = await search(query, signal);
        if (generation === current && !signal.aborted) onResult(result);
      } catch (error) {
        if (generation === current && !signal.aborted && onError) onError(error);
      }
    } };
  }
  function init(win) {
    var doc = win.document;
    if (doc.documentElement.dataset.packriftSearchReady) return;
    doc.documentElement.dataset.packriftSearchReady = 'true';
    var storage;
    try { storage = win.sessionStorage; } catch (_) { /* Storage can be blocked by browser policy. */ }
    var client = createSearchClient({ origin: win.location.origin,
      storage: storage, locale: (win.Shopify && win.Shopify.locale) || doc.documentElement.lang,
      country: win.Shopify && win.Shopify.country,
      root: win.Shopify && win.Shopify.routes && win.Shopify.routes.root,
      fetch: win.fetch.bind(win) });
    var serial = 0;
    function eligible(input) {
      if (!input || !input.matches('input[name="q"]') || !input.form) return false;
      try {
        var action = new URL(input.form.action, win.location.href);
        return action.origin === win.location.origin && /\/search\/?$/.test(action.pathname)
          && input.form.method.toLowerCase() === 'get';
      } catch (_) { return false; }
    }
    // Capture submission regardless of whether a predictive widget initialized.
    doc.addEventListener('submit', function (event) {
      var input = event.target.querySelector && event.target.querySelector('input[name="q"]');
      if (eligible(input)) input.value = normalizeQuery(input.value);
    }, true);
    function enhance(input) {
      if (!eligible(input) || input.dataset.packriftSearch || input.hasAttribute('aria-controls')) return;
      input.dataset.packriftSearch = 'true';
      var id = 'pk-search-suggestions-' + (++serial);
      var panel = doc.createElement('div');
      panel.className = 'pk-search-suggestions'; panel.hidden = true;
      var list = doc.createElement('div'); list.id = id; list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', 'Product suggestions');
      var status = doc.createElement('div'); status.className = 'pk-search-suggestions__status';
      status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite');
      panel.append(list, status); doc.body.append(panel);
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', id); input.setAttribute('aria-expanded', 'false');
      input.setAttribute('autocomplete', 'off');
      var timer, links = [], active = -1, composing = false;
      function close() {
        clearTimeout(timer); latest.cancel(); panel.hidden = true;
        input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1;
      }
      function position() {
        if (panel.hidden) return;
        var rect = input.getBoundingClientRect();
        panel.style.left = Math.max(8, Math.min(rect.left, win.innerWidth - 288)) + 'px';
        panel.style.top = Math.min(rect.bottom + 4, win.innerHeight - 80) + 'px';
        panel.style.width = Math.min(Math.max(rect.width, 280), win.innerWidth - 16) + 'px';
      }
      function render(result) {
        if (doc.activeElement !== input || composing) return;
        list.replaceChildren(); links = []; active = -1;
        input.removeAttribute('aria-activedescendant');
        function group(label, items) {
          if (!items.length) return;
          var heading = doc.createElement('div'); heading.className = 'pk-search-suggestions__label';
          heading.setAttribute('role', 'presentation'); heading.textContent = label; list.append(heading);
          items.forEach(function (item) {
            var link = doc.createElement('a'); link.href = item.url; link.textContent = item.title;
            link.id = id + '-' + links.length; link.tabIndex = -1;
            link.setAttribute('role', 'option'); link.setAttribute('aria-selected', 'false');
            link.addEventListener('pointerdown', function (event) { event.preventDefault(); });
            links.push(link); list.append(link);
          });
        }
        group('Exact SKU — verify product details', result.exact_sku || []);
        group('Same dimension numbers — verify units and pack count', result.exact);
        group(result.has_dimensions ? 'Other sizes or unspecified dimensions' : 'Products', result.alternatives);
        status.textContent = links.length ? 'Check product details for pack count and availability. Enter searches all products.'
          : 'No suggestions. Press Enter to search all products.';
        panel.hidden = false; input.setAttribute('aria-expanded', 'true'); position();
      }
      function unavailable() {
        if (doc.activeElement !== input || composing) return;
        list.replaceChildren(); links = []; active = -1;
        input.removeAttribute('aria-activedescendant');
        status.textContent = 'Suggestions unavailable. Press Enter to search all products.';
        panel.hidden = false; input.setAttribute('aria-expanded', 'true'); position();
      }
      var latest = createLatestSearch(client, render, unavailable);
      function schedule() {
        clearTimeout(timer); latest.cancel();
        // Hide old options immediately so Enter cannot select a previous query.
        panel.hidden = true; links = []; active = -1;
        input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant');
        if (composing || input.value.trim().length < 2) return;
        // Fresh public suggestions are ready now, including after a page reload.
        var cached = client.peek(input.value);
        if (cached) { render(cached); return; }
        timer = setTimeout(function () { latest.run(input.value); }, 120);
      }
      input.addEventListener('input', schedule);
      input.addEventListener('focus', schedule);
      input.addEventListener('compositionstart', function () { composing = true; close(); });
      input.addEventListener('compositionend', function () { composing = false; schedule(); });
      input.addEventListener('blur', close);
      input.form.addEventListener('reset', close);
      input.addEventListener('keydown', function (event) {
        if (composing || event.isComposing) return;
        if (event.key === 'Escape') { close(); return; }
        if (panel.hidden || !links.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = active < 0 ? (event.key === 'ArrowDown' ? 0 : links.length - 1)
            : (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links.forEach(function (link, i) { link.setAttribute('aria-selected', String(i === active)); });
          input.setAttribute('aria-activedescendant', links[active].id);
          links[active].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault(); links[active].click();
        }
      });
      doc.addEventListener('pointerdown', function (event) {
        if (event.target !== input && !panel.contains(event.target)) close();
      });
      win.addEventListener('resize', position); win.addEventListener('scroll', position, true);
      if (doc.activeElement === input) schedule();
    }
    function start() {
      var style = doc.createElement('style');
      style.textContent = '.pk-search-suggestions{position:fixed;z-index:10000;max-height:50vh;overflow:auto;background:#fff;color:#172126;border:1px solid #c9d2d6;border-radius:8px;box-shadow:0 8px 24px #0002;text-align:left;font:14px/1.4 system-ui,sans-serif}.pk-search-suggestions[hidden]{display:none}.pk-search-suggestions a{display:block;padding:10px 12px;color:#172126;text-decoration:none;white-space:normal}.pk-search-suggestions a:hover,.pk-search-suggestions a[aria-selected="true"]{background:#e8f2ef;outline:2px solid #197356;outline-offset:-2px}.pk-search-suggestions__label{padding:10px 12px 4px;font-size:12px;font-weight:700}.pk-search-suggestions__status{padding:10px 12px;font-size:12px;color:#4c5c63;border-top:1px solid #e6eaec}';
      doc.head.append(style);
      doc.querySelectorAll('input[name="q"]').forEach(enhance);
      // Lazy enhancement also handles newly mounted header/search drawers.
      doc.addEventListener('focusin', function (event) { enhance(event.target); });
    }
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    // Add a uniquely named, read-only tool; never replace Shopify's native tools.
    var attempts = 0;
    async function register() {
      // The Packrift WebMCP bundle registers search_packaging (full catalog) instead.
      if (win.__PACKRIFT_WEBMCP__ && win.__PACKRIFT_WEBMCP__.ownsSearchTool) return;
      var context = doc.modelContext || (win.navigator && win.navigator.modelContext);
      if (!context || typeof context.registerTool !== 'function') {
        if (++attempts < 32) setTimeout(register, 250);
        return;
      }
      try {
        if (typeof context.getTools === 'function') {
          var registered = await context.getTools();
          if (Array.isArray(registered) && registered.some(function (tool) { return tool.name === 'search_packaging_exact'; })) return;
        }
        var registration = context.registerTool({ name: 'search_packaging_exact',
          description: 'Read-only Packrift onsite product search. Normalizes dimension separators. SKU matches require returned SKU data. Dimension matches compare numbers and order in product titles only; verify units, grade, material, pack count and availability on the product page. Searches at most 10 predictive candidates and returns at most 5 product links; not an exhaustive catalog search.',
          inputSchema: { type: 'object', properties: { query: { type: 'string', minLength: 2, maxLength: 200 } }, required: ['query'], additionalProperties: false },
          annotations: { readOnlyHint: true, destructiveHint: false, idempotentHint: true, openWorldHint: false },
          execute: async function (args) {
            if (!args || typeof args.query !== 'string' || args.query.trim().length < 2 || args.query.length > 200) throw new Error('Provide a query of 2–200 characters.');
            var result = await client(args.query);
            return { content: [{ type: 'text', text: JSON.stringify(result) }] };
          } });
        if (registration && typeof registration.catch === 'function') registration.catch(function () {});
      } catch (_) { /* Unsupported experimental surface: native search remains available. */ }
    }
    register();
  }
  return { normalizeQuery: normalizeQuery, dimensions: dimensions, rankProducts: rankProducts,
    canonicalProductUrl: canonicalProductUrl, createSearchClient: createSearchClient,
    createLatestSearch: createLatestSearch, init: init };
});
